<script setup lang="ts">
import { watch } from "vue";
import { usePensionOptionsStore } from "../stores/pensionOptions";
import { Question, RadioSet, Radio } from "./fields";
import { tooltips } from "../tooltips/pensionOptionsTooltips";
import { pensionOptionsValidator } from "../utils/validators";

const store = usePensionOptionsStore();
const validator = pensionOptionsValidator(store);

watch(() => store.annuityExceedMaximum, (newValue) => {
    if (newValue === false) {
        store.acknowledgementILSA = null;
    }
});

</script>

<template>
    <Question
        type="group"
        name="annuityExceedMaximum"
        label="Does the value of the tax-free lump sum you intend to take, have already taken,
            or want to take at the same time, exceed the individual Lump Sum Allowance of £268,275?"
        :tooltip="tooltips.annuityExceedMaximum"
    >
        <RadioSet>
            <Radio
                v-model="store.annuityExceedMaximum"
                title="Yes"
                :value="true"
                :validation="validator.annuityExceedMaximum"
            />
            <Radio
                v-model="store.annuityExceedMaximum"
                title="No"
                :value="false"
                :validation="validator.annuityExceedMaximum"
            />
        </RadioSet>
    </Question>
    <Question
        v-cloak
        v-if="store.annuityExceedMaximum"
        type="group"
        name="acknowledgementILSA"
        label="Do you acknowledge that any amount taken over the iLSA may result in additional tax being payable?"
    >
        <RadioSet>
            <Radio
                v-model="store.acknowledgementILSA"
                title="Yes"
                :value="true"
                :validation="validator.acknowledgementILSA"
            />
        </RadioSet>
        <div class="col-12 input-notification">
            <p>
                For more information, please visit the <a
                    href="https://www.gov.uk/tax-on-pension/tax-free"
                    target="_blank"
                >Government website</a>, speak to your pension provider(s) or a regulated financial advisor.
            </p>
        </div>
    </Question>
</template>
